import { useCallback, useContext } from 'react';

import { ModalsWrapperContext } from '@kanda-libs/ks-design-library';

import { HELP_MODAL_ID } from './constants';

export interface HelpModalHook {
  showHelpModal: (e?: React.MouseEvent<HTMLElement>) => void;
  hideHelpModal: (e?: React.MouseEvent<HTMLElement>) => void;
}

export default function useHelpModal(): HelpModalHook {
  const { showModal, hideModal } = useContext(ModalsWrapperContext);

  const showHelpModal = useCallback(
    (e?: React.MouseEvent<HTMLElement>) => {
      if (e && typeof e.stopPropagation === 'function') {
        e.stopPropagation();
      }
      showModal(HELP_MODAL_ID);
    },
    [showModal],
  );

  const hideHelpModal = useCallback(
    (e?: React.MouseEvent<HTMLElement>) => {
      if (e && typeof e.stopPropagation === 'function') {
        e.stopPropagation();
      }
      hideModal(HELP_MODAL_ID);
    },
    [hideModal],
  );

  return {
    showHelpModal,
    hideHelpModal,
  };
}
